import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-users-container" }
const _hoisted_2 = {
  class: "card",
  style: {"padding-top":"41px"}
}
const _hoisted_3 = {
  class: "card-header align-items-center",
  style: {"padding-bottom":"22px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "User Management"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 sub-title" }, " Fill in the form below to get a tenant reference ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" New User ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-circle symbol-50px overflow-hidden me-3" }
const _hoisted_11 = { class: "symbol-label fs-3 bg-light-info text-info" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "text-gray-800 text-hover-primary mb-1" }
const _hoisted_14 = { class: "text-capitalize" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-edit text-primary",
  style: {}
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-trash text-primary",
  style: {}
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_UserModal = _resolveComponent("UserModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-new-design-primary w-180-px",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createNewUser && _ctx.createNewUser(...args)))
          }, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DataTable, {
          items: _ctx.getUserList,
          headers: _ctx.headers,
          totalPages: _ctx.totalPages,
          page: _ctx.currentPage,
          perPage: 15,
          "max-visible-buttons": 5,
          onOnPageChanged: _ctx.onPageChanged
        }, {
          name: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", null, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.first_name && item.last_name
                        ? _ctx.$filters.acronym(
                            item.first_name + ' ' + item.last_name
                          )
                        : _ctx.$filters.acronym(item.email)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", _hoisted_13, _toDisplayString(item.first_name ? _ctx.$filters.capitalize(item.first_name) : '') + " " + _toDisplayString(item.last_name ? _ctx.$filters.capitalize(item.last_name) : ''), 1)
              ])
            ])
          ]),
          roles: _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$filters.formatRoleText(item.roles.join(', '))), 1)
          ]),
          action: _withCtx(({ item }) => [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.editUser(item)),
              class: "btn btn-icon"
            }, _hoisted_17, 8, _hoisted_15),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.deleteUser(item.id)),
              class: _normalizeClass(["btn btn-icon", { disabled: item.id === _ctx.authUser.id }])
            }, _hoisted_20, 10, _hoisted_18)
          ]),
          _: 1
        }, 8, ["items", "headers", "totalPages", "page", "onOnPageChanged"])
      ]),
      _createVNode(_component_UserModal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
        loading: _ctx.loading,
        selectedUser: _ctx.selectedUser,
        onFormSubmitted: _ctx.handleFormSubmitted,
        ref: "userModal"
      }, null, 8, ["modelValue", "loading", "selectedUser", "onFormSubmitted"])
    ])
  ]))
}